import axios from 'axios';
import React, { useState } from 'react'
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import Skeleton from "@mui/material/Skeleton";
import ReviewItem from './Reviews';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button, Modal } from "react-bootstrap";
import Rating from '@mui/material/Rating';
import { useDispatch } from 'react-redux';
const ReviewsList = () => {
  const dispatch = useDispatch()
  const [reviews, setReviews] = React.useState([]);
  const [arrangement, setArrangement] = useState("");
  const [rating, setRating] = useState("");
  const [review, setReview] = useState("internship.review");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [courseId, setCourseId] = useState("");
  const [status, setStatus] = useState("");
  
  const getReviews = async () => {
    dispatch({type:'LOADING'})
    try {
      const response = await axios.get(`${ENDPOINT}get-reviews.php`, SecurityHeaders);
      if (response.data.status==="success") {
        setReviews(response.data.data);
        dispatch({type:'DONE_LOADING'})
        
      }
    } catch (error) {
   dispatch({type:'ERROR',payload:error.message})
    }
  }

  React.useEffect(() => {
    getReviews();
  }, [])
const [addReview, setAddReview] = React.useState(false);
  const handleClose = () => setAddReview(false);
  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''
  
  });
  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(open=>({...open,open:false}));
  };

  const AddReview = async (e) => {
    dispatch({type:'LOADING'})
    e.preventDefault();

    const formData = new FormData();

    formData.append("arrangement", arrangement);
    formData.append("rating", rating);
    formData.append("review", review);
    formData.append("email", email);
    formData.append("name", name);
    formData.append("profile_pic", profilePic);
    formData.append("course_id", courseId);
    formData.append("status", status);

    try {
   
      const response = await axios.post(`${ENDPOINT}admin-add-review.php`, formData, SecurityHeaders);
      if (response.data.status === "success") {
        dispatch({type:'DONE_LOADING'})
        setArrangement("")
        setRating("")
        setReview("")
        setEmail("")
        setName("")
        setProfilePic("")
        setCourseId("")
        setStatus("")
 
        setAddReview(false);   
        setOpen({open: true, message: response.data.message, type:'success'});  
        getReviews();  
      }
       else {       
      dispatch({type:'ERROR',payload:response.data.message}); 
      } 
    } catch (error) {
  dispatch({type:'ERROR',payload:error.message});
    }
  };

  return (
   <>
     <Snackbar open={open.open} onClose={handleClose2} autoHideDuration={4000} >
          <Alert
            
            severity={open.type === 'success' ? 'success' : 'error'}
            onClose={() => {}}
            variant="filled"
               
  
          >
            {open.message}
          </Alert>
        </Snackbar>
       
        <Modal show={addReview} onHide={handleClose}>
          <Modal.Body>
          <div>
      <h2>Update Review</h2>
    
      <form onSubmit={AddReview}>

      <div className="mb-3">
          <label htmlFor="arguments" className="form-label">Arguments</label>
        <input type="text" className='form-control' placeholder="Arrangement" value={arrangement} onChange={(e) => setArrangement(e.target.value)} />

        </div>
      
        <div className="mb-3">
          <label htmlFor="Review" className="form-label">Review</label>
        <textarea placeholder="Review" className='form-control' value={review} onChange={(e) => setReview(e.target.value)} />

        </div>
        <div className="mb-3">
          <label htmlFor="Review" className="form-label">Email</label>
        <input type="email" className='form-control' placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />

        </div>
        <div className="mb-3">
          <label htmlFor="Review" className="form-label">Name</label>
        <input type="text" className='form-control' placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />

        </div>
        <div className="mb-3">
          <label htmlFor="Review" className="form-label">Profile URL</label>
        <input type="text" className='form-control'  placeholder="Profile Pic URL" value={profilePic} onChange={(e) => setProfilePic(e.target.value)} />

        </div>
        <div className="mb-3">
          <label htmlFor="Review" className="form-label">Course Id</label>
        <input type="text"className='form-control' placeholder="Course ID" value={courseId} onChange={(e) => setCourseId(e.target.value)} />

        </div>
        <div className="mb-3">
          <label htmlFor="Review" className="form-label">Status</label>
        <select type="text" className='form-control' placeholder="Status" value={status} onChange={(e) => setStatus(e.target.value)} >
        <option value="pending">Pending</option>
        <option value="approved">approved</option>
        <option value="rejected">Rejected</option>

        </select>

        </div>
      <div className="mb-3">
                      <div>
                      <label htmlFor="Review" className="form-label">Status</label>
                      </div>
     
                     <Rating
                     name="simple-controlled"
                     value={rating}
                     onChange={(event, newValue) => {
                       setRating(newValue);
                     }}
                   />
                     </div>
       
<div className="mb-3 d-flex justify-content-center " >
<button className='btn btn-primary w-fit' type="submit">Add Review</button>

  </div>
        </form>
    </div>
                </Modal.Body>
        </Modal>
   {reviews?   
    <div className="card">
      <div className="d-flex justify-content-end py-3 me-4">
        <button  onClick={()=>setAddReview(true)}  className='btn btn-success' >Add Review</button>
        </div>
          <div className="row">
            <div className="table-responsive">
              <table className="table table-borderless mb-0">

                <thead className="table-light">
                  <tr>
                    <th scope="col">Reviews</th>
                    <th scope="col">Rating</th>
                    <th scope="col">Date</th>

                  </tr>
                </thead>

                <>
                  <tbody className="overflow">
                    {reviews ? (
                      reviews.map((internship, index) => (
                     <ReviewItem reload={getReviews} internship={internship} key={internship.id} />
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          <Skeleton variant="text" />
                          <Skeleton variant="text" />
                          <Skeleton variant="text" />
                        </td>
                      </tr>
                    )}
                  </tbody>

                </>
              </table>
            </div>


          </div>
        </div> : <p>No reviews found</p>}  

   

  

   </>
  )
}

export default ReviewsList